import { createPinia } from 'pinia';
import { createEventBus } from 'js/utils/eventBus';

const pinia = createPinia();

export default pinia;

export const SmartViewEventBus = createEventBus();
